module.exports = __webpack_public_path__ + "img/zhewan4.70533cbf.png";